$(function(){

    $('body').on('click', '.integer-btn', function(){
        let integer = $(this).siblings('input'),
            integerVal = parseInt(integer.val());

        if ($(this).hasClass('integer-increase')) {
            integer.increaseInteger();
        } else {
            integer.decreaseInteger();
        }

        if (integerVal !== parseInt(integer.val())) {
            integer[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

    $.fn.increaseInteger = function() {
        let integer = $(this);

        if (integer.attr('max') && parseInt(integer.val()) >= parseInt(integer.attr('max'))) {
            return;
        }

        integer.val(parseInt(integer.val()) + 1);
    };

    $.fn.decreaseInteger = function() {
        let integer = $(this);

        if (integer.attr('min') && parseInt(integer.val()) <= parseInt(integer.attr('min'))) {
            return;
        }

        integer.val(parseInt(integer.val()) - 1);
    };
})